import React from 'react';
import { Box, Grid } from "@mui/material"
import { useRouteError } from "react-router-dom"
import Logo from "./assets/Logo_TotalEnergies.svg.png"
import "./components/Oauth/login.css";

const ERROR_RELOAD_KEY = "error-element-reloaded-at";
const ERROR_RELOAD_COOLDOWN_MS = 30000;

export const ErrorFallback = () => (
  <Box sx={{ display: "flex", justifyContent: "center", textAlign: "center", paddingTop: "20vh", paddingLeft: "10vw", paddingRight: "10vw" }}>
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <div>
          <img className="login-te-logo" src={Logo} alt="te-logo" />
        </div>
      </Grid>
      <Grid item xs={12}>
        <h2>La plateforme a rencontré une erreur. Vous pouvez nous contacter à l'adresse suivante : support@datakeen.co.</h2>
      </Grid>
    </Grid>
  </Box>
);

// errorElement des routes : remplace l'écran développeur par défaut de React Router.
// Recharge la page une fois (anti-boucle de 30s) pour se remettre d'un DOM modifié
// par une extension / un traducteur, sinon affiche le message d'erreur.
export const RouteErrorElement = () => {
  const error = useRouteError();

  React.useEffect(() => {
    console.error("Error caught in route errorElement: ", error);
    try {
      const last = Number(window.sessionStorage.getItem(ERROR_RELOAD_KEY) || 0);
      if (Date.now() - last > ERROR_RELOAD_COOLDOWN_MS) {
        window.sessionStorage.setItem(ERROR_RELOAD_KEY, String(Date.now()));
        window.location.reload();
      }
    } catch (e) {
      // sessionStorage indisponible : on affiche simplement le message
    }
  }, [error]);

  return <ErrorFallback />;
};

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, ErrorBoundaryState> {
  constructor(props: React.PropsWithChildren<{}>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state to trigger fallback UI
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error caught in ErrorBoundary: ", error, errorInfo);
  }

  componentDidUpdate() {
    if (this.state.hasError) {
      const pageHasAlreadyBeenForceRefreshed = JSON.parse(
        window.localStorage.getItem('page-has-been-force-refreshed') || 'false'
      );
      if (!pageHasAlreadyBeenForceRefreshed) {
        window.localStorage.setItem('page-has-been-force-refreshed', 'true');
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;